<template>
  <div>
    <div
      v-if="hasCreatePermission('Roles')"
      class="button-filled flex flex-row items-center gap-1 px-3 py-2"
      @click="openAddPopup()"
    >
      <span class="material-symbols-outlined text-[24px] text-white">add</span>
      <span>{{ $t('ROLES.HEADER_BTN_TXT') }}</span>
    </div>

    <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
      <add-role :on-close="hideAddPopup" />
    </woot-modal>
  </div>
</template>

<script>
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import AddRole from './AddRole.vue';

export default {
  components: { AddRole },
  mixins: [hasPermissionMixin],
  data() {
    return {
      loading: {},
      showAddPopup: false,
      agentAPI: {
        message: '',
      },
      currentAgent: {},
    };
  },
  methods: {
    openAddPopup() {
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.showAddPopup = false;
    },
  },
};
</script>
